import React, { useEffect, useState } from "react";
import { Button, Table, Modal, Empty } from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import { get_language, translate } from "../../locale";
import UserServices from "../../services/UserServices";
import moment from "moment";
import { useParams } from "react-router-dom";
import { TableHelper } from "../../helpers/TableHelper";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const PillsSentTable = ({ reload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalDetails, setModalDetails] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const { username, days } = useParams();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => handleShowDetails(record)}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Fecha"),
      dataIndex: "register_date",
      key: "register_date",
      render: (_, record) =>
        moment(record.register_date).format(
          get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
        ),
      sorter: { multiple: 1 },
    },
    {
      title: translate("Remitente"),
      dataIndex: "sender",
      key: "sender",
      render: (_, record) => record.sender,
      sorter: { multiple: 2 },
    },
    {
      title: translate("Título"),
      dataIndex: "name",
      key: "name",
      render: (_, record) => record.pill.name,
      sorter: { multiple: 3 },
    },
  ];

  useEffect(() => {
    if (reload !== null) {
      loadData();
    }
  }, [reload]);

  useEffect(() => {
    loadData();
  }, [JSON.stringify(tableParams)]);

  const loadData = async () => {
    setLoading(true);
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    try {
      const response = await UserServices.getUserPills(username, days, data);
      if (response.status >= 200 && response.status < 300) {
        setData(
          response.data.data.map((i) => ({
            ...i,
            sender:
              i.sender === null ? "Protocolo automático" : i.sender.username,
          }))
        );
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleShowDetails = (data) => {
    setModalDetails(true);
    setSelectedData(data);
  };

  const handleHideDetails = () => {
    setModalDetails(false);
  };
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => {
          return i.id.toString();
        }}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <Modal
        open={modalDetails}
        title={translate("Píldora")}
        onCancel={handleHideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={handleHideDetails}>
            {translate("Aceptar")}
          </Button>,
        ]}
      >
        {selectedData !== null && (
          <>
            <p>
              <strong>{translate("Fecha")}: </strong>{" "}
              {moment(selectedData.date).format(
                get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
              )}
              <br />
              <strong>{translate("Remitente")}: </strong>{" "}
              {selectedData.sender.username}
              <br />
              <strong>{translate("Título")}: </strong> {selectedData.pill.name}
              <br />
              <strong>{translate("Descripción")}: </strong>
            </p>
            {selectedData.pill.description}
          </>
        )}
      </Modal>
    </>
  );
};

export default PillsSentTable;
